<template>
    <v-tour
        ref="tour"
        :name="name"
        :steps="steps"
        :options="options"
        :callbacks="callbacks"
    />
</template>

<script>
import i18n from '@/i18n';
import Shift from '@/models/Shift'

export default {
    props: {
        name: {
            type: String,
            default: 'appTour'
        },
    },

    created() {
        this.callbacks.onStart = this.onStart;
    },

    data: () => {
        return {
            callbacks: {
                onStart: () => {}
            },
        }
    },

    watch: {
        $route (to, from){
            this.$refs.tour.stop()
        }
    },

    computed: {
        steps() {
            // if(this.$route.name === 'tables' || this.$route.name === 'allegraOrder') {
            //     let curShift = Shift.current()
            //     if(curShift && moment.duration(moment().diff(moment(curShift.opened_at))).asHours() > 48) {
            //         return this.allSteps['closeShift'];
            //     }
            // }

            return this.allSteps[this.$route.name];
        },

        allSteps() {
            return {
                // closeShift: [
                //     { target: '#shift-btn', header: { title: i18n.t('tour.closeShift.step1_header') }, content: i18n.t('tour.closeShift.step1'), params: { placement: !isAllegra ? 'top' : 'right' } },
                //     { target: '#staff-btn', header: { title: i18n.t('tour.closeShift.step2_header') }, content: i18n.t('tour.closeShift.step2'), params: { placement: !isAllegra ? 'top' : 'right' } },
                // ],
                tables: [],
                order: [],
                allegraOrder: [],
                adminDashboard: [],
                adminUsers: [],
                adminUserRoles: [],
                adminProducts: [],
                adminOrderItemComments: [],
                adminProductCategories: [],
                adminReceptions: [],
                adminDispatches: [],
                adminOrders: [],
                adminReports: [],
                adminWorkingHours: [],
                adminAccount: [],
                adminTablesSettings: [],
                adminOrderSettings: [],
                adminTaxRates: [],
                adminPrinters: [],
                adminClients: [],
            }
        },

        options() {
            return {
                highlight: false,
                labels: {
                    buttonSkip: i18n.t('tour.button_skip'),
                    buttonPrevious: i18n.t('tour.button_previous'),
                    buttonNext: i18n.t('tour.button_next'),
                    buttonStop: i18n.t('tour.button_stop')
                }
            }
        },
    },

    methods: {
        onStart() {
            if(!this.steps.length) {
                // this.$snackbar(this.$t('general.coming_soon'), 'success');
            }
        }
    }
};
</script>
